var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcnVisibilityOff(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 18,
    viewBox: "0 0 20 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.011 11.1172C7.436 10.5432 7.086 9.7632 7.086 8.8882C7.086 7.1352 8.498 5.7222 10.25 5.7222C11.117 5.7222 11.915 6.0732 12.48 6.6472",
    stroke: "#475496",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3552 9.4493C13.1232 10.7393 12.1072 11.7573 10.8182 11.9913",
    stroke: "#475496",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.905 14.2227C3.318 12.9767 1.974 11.1567 1 8.8877C1.984 6.6087 3.337 4.7787 4.934 3.5227C6.521 2.2667 8.352 1.5847 10.25 1.5847C12.159 1.5847 13.989 2.2767 15.586 3.5417",
    stroke: "#475496",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.698 5.7412C18.386 6.6552 18.991 7.7102 19.5 8.8872C17.533 13.4442 14.057 16.1892 10.25 16.1892C9.387 16.1892 8.536 16.0492 7.718 15.7762",
    stroke: "#475496",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1374 1L2.3634 16.774",
    stroke: "#475496",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnVisibilityOff);
export default __webpack_public_path__ + "static/media/icn-visibility-off.184830067847443e26f0ff563879f74d.svg";
export { ForwardRef as ReactComponent };